/**
 * Layout for public content pages (About, Contact, Help, Pricing, etc.)
 * Green/black theme, same header/footer as landing.
 */

import React from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

const PublicPageLayout = ({ children }) => (
  <>
    <PublicHeader />
    <main className="public-page">
      <div className="public-page-inner">
        {children}
      </div>
    </main>
    <PublicFooter />
  </>
);

export default PublicPageLayout;
